module.exports = __webpack_public_path__ + "static/media/MenuClosed.c5b32cda.svg";